import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';

import { useAdvancedSearchFormContext } from '../../types';

import { NumberFieldWrapper } from './numberFieldWrapper';

export const FestenummerField = () => {
  const { t } = useTranslation();
  const { control } = useAdvancedSearchFormContext();

  const label = t(`search.advanced.field_festenummer`);

  return (
    <Controller
      control={control}
      name="festenummer"
      render={({ field, fieldState }) => {
        return (
          <NumberFieldWrapper
            onValueChange={(e) => field.onChange(e.value)}
            error={!!fieldState?.error}
            fieldLabel={label}
            {...field}
          />
        );
      }}
    />
  );
};
